<svelte:body on:item={put_item} />
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import RalColor from "../../parts/RalColor.svelte";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            // Штора плиссе 240x400, Белый RAL 9016 - цвет профилей, Не прозрачная (BLACKOUT), антрацит-крем - шторка, белый - комплектующие, белая - нить, Картоный короб - упаковка

            let title = item.title.split(' ', 3);

            width.set(title[2].split('x')[0]);
            height.set((title[2].split('x')[1]).replace(',',''));

            title = item.title.split(',');


            for (var key in color) {
                if (title[1].includes(color[key])) {
                    ind2 = color[key];
                }
            }



            for (let [key, value] of Object.entries(shtorytypes)) {
                if (title[2].includes(key)) {
                    ind3 = key;
                }
            }


            if (ind3=='Полупрозрачная'){
                for (var element of shtoryPoluprozcolor) {
                    if (title[3].includes(element)) {
                        ind4 = element;
                    }
                }
            }
            else if(ind3=='Не прозрачная (BLACKOUT)'){
                for (var element of shtoryBlackoutcolor) {
                    if (title[3].includes(element)) {
                        ind4 = element;
                    }
                }
            }
            else if(ind3=='СОТА полупрозрачная'){
                for (var element of shtorySotaPoluprozcolor) {
                    if (title[3].includes(element)) {
                        ind4 = element;
                    }
                }
            }
            else {
                for (var element of shtorySotacolor) {
                    if (title[3].includes(element)) {
                        ind4 = element;
                    }
                }

            }


            for (var element of komplektcolor) {
                if (title[4].includes(element)) {
                    ind5 = element;
                }
            }

            for (var element of nitcolor) {
                if (title[5].includes(element)) {
                    ind6 = element;
                }
            }
            for (var element of upakovka) {
                if (title[6].includes(element)) {
                    ind7 = element;
                }
            }

            count.set(+item.quantity);
            comment.set(item.comment);

            fetchData = await fetch();
            change();
        }
    };


    const color = options.color || {
        'Белый RAL 9016': 'Белый RAL 9016',
        'Кремовый RAL 1013': 'Кремовый RAL 1013',
        'Серый RAL 7040': 'Серый RAL 7040',
        'Коричневый RAL 8017': 'Коричневый RAL 8017',
        'Антрацит RAL 7016': 'Антрацит RAL 7016',
        'Черный RAL 9005': 'Черный RAL 9005',
        'Алюминиевый натуральный': 'Алюминиевый натуральный',
    };





    const shtorytypes = options.shtorytypes || {
        'Полупрозрачная' : 'Полупрозрачная',
        'Не прозрачная (BLACKOUT)' : 'Не прозрачная (BLACKOUT)',
        'СОТЫ (BLACKOUT)' : 'СОТЫ (BLACKOUT)',
        'СОТА полупрозрачная' : 'СОТА полупрозрачная',
    };






    const shtoryPoluprozcolor  = options.shtoryPoluprozcolor || [
        'белая',
        'серая',
        'кремовая',
        'бежевая',
        'темно-синий',
        'коричневая',
        'норковая',
        'антрацит',
    ];

    const shtoryBlackoutcolor  = options.shtoryBlackoutcolor || [
         'антрацит-крем',
         'серая-кремовая',
    ];

    const shtorySotacolor  = options.shtorySotacolor || [
        'светло-серый',
        'коричневый',
        'темно-серый',
        'белый',
    ];


    const shtorySotaPoluprozcolor  = options.shtorySotaPoluprozcolor || [
        'белый',
    ];

    const shtoryBlackoutodnosloy  = options.shtoryBlackoutodnosloy || [
        'Белый',
        'Серый',
        'Бежевый',
        'Антрацит',
    ];

    const komplektcolor = options.komplektcolor || [
        'белый',
        'серый',
        'кремовый',
        'коричневый',
        'черный',
    ];

    const nitcolor = options.nitcolor || [
        'белая',
        'серая',
        'кремовая',
        'бежевая',
        'темно-синяя',
        'коричневая',
        'норка',
        'антрацит',
    ];

    const upakovka = options.upakovka || [
        'Картонный короб',
        'Пузырчатая пленка',
        'Стрейч пленка',
    ];



    const fetch = async (color = 'Белый') => {
        let result = await network.fetch_data('Шторы плиссе', '', '');
        let options = await network.fetch_ind('Шторы плиссе');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let
        width = parameter('width', '240'),
        height = parameter('height', '400'),
        ind1 =  '', //
        ind2 = 'Белый RAL 9016', // цвет
        ind3 = 'Полупрозрачная', // тип шторки
        ind4 = 'белая', // цвет шторки
        ind5 = 'белый', // Цвет комплектующих
        ind6 = 'белая', // Цвет нити
        ind7 = 'Картонный короб', // Упаковка


        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    let fetchData = fetch();

   /* let
        montage_item,
        montage_price = 1;*/


    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,
            w = +$width,
            h = +$height
        ;

        let result = {
            type: 'шторы-плиссе',
            name: 'Шторы плиссе',
            subname: [
                $width + 'x' + $height, ', ',
                ind2, ' - цвет профилей, ', ind3, ', ', ind4, ' - шторка, ', ind5, ' - комплектующие, ', ind6, ' - нить, ', ind7, ' - упаковка'
            ].join(''),
            title: [
                'Шторы плиссе', ' ', $width + 'x' + $height, ', ',
                ind2, ' - цвет профилей, ', ind3, ', ', ind4, ' - шторка, ', ind5, ' - комплектующие, ', ind6, ' - нить, ', ind7, ' - упаковка'
            ].join(''),
            params: {
                ind1: [ind5, ' - комплектующие, ', ind6, ' - нить, ', ind7, ' - упаковка'].join(''),
                ind2: ind2,
                ind3: [ind3, ', ', ind4].join(''),
                ind4: w,
                ind5: h,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture:  options.vStrukture || 35
        };

        _.forEach(data.result, function (item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;


            if (name.includes('профиль') && name.includes(ind2.toLowerCase())) {
                kolvo = ((w - 10) * 2 / 1000 ).toFixed(3);
            }

            if (APP_TYPE === 'setkipro'){

                if (name.includes('плиссированная шторка') &&  !ind3.toLowerCase().includes('СОТЫ (BLACKOUT)'.toLowerCase())) {
                    if (name.includes('blackout') && ind3.toLowerCase().includes('Не прозрачная (BLACKOUT)'.toLowerCase()) && name.includes(ind4.toLowerCase()) ){
                        kolvo = ((w - 2) * h / 2.2 * 0.028  / 10000 ).toFixed(3);
                    }
                    if (!name.includes('blackout') && !ind3.toLowerCase().includes('Не прозрачная (BLACKOUT)'.toLowerCase()) && name.includes(ind4.toLowerCase()) ){
                        kolvo = ((w - 2) * h / 2.2 * 0.028  / 10000 ).toFixed(3);
                    }
                }

                if (name.includes('ШТОРКА BLACKOUT'.toLowerCase())  &&  ind3.toLowerCase().includes('СОТЫ (BLACKOUT)'.toLowerCase()) ) {
                    if (name.includes(' сота')  && name.includes(ind4.toLowerCase()) ){
                        kolvo = ((w / 1000) * h / 7.7 * 10  / 1000 ).toFixed(3);
                    }
                }

                if (name.includes('ШТОРКА полупрозрачная СОТА'.toLowerCase()) && ind3.toLowerCase().includes('СОТА полупрозрачная'.toLowerCase())) {
                    if ( name.includes(ind4.toLowerCase()) ){
                        kolvo = ((w / 1000) * h / 7.7 * 10  / 1000 ).toFixed(3);
                    }
                }
            }

            if (APP_TYPE === 'axis-one'  ){

                if (name.includes('ПЛИССИРОВАННАЯ ШТОРКА ИЗ ПОЛИЭСТЕРА'.toLowerCase()) && ind3=='Полупрозрачная') {
                    if (name.includes('ПЛИССИРОВАННАЯ ШТОРКА ИЗ ПОЛИЭСТЕРА'.toLowerCase()) && name.includes(ind4.toLowerCase() + ' ') ){
                        kolvo = ((w - 2) * h / 2.2 * 0.028  / 10000 ).toFixed(3);
                    }
                }
                if (name.includes('ШТОРКА BLACKOUT'.toLowerCase())  &&  ind3.toLowerCase().includes('СОТЫ (BLACKOUT)'.toLowerCase()) ) {
                    if (name.includes(' сота')  && name.includes(ind4.toLowerCase()) ){
                        kolvo = ((w / 1000) * h / 7.7 * 10  / 1000 ).toFixed(3);
                    }
                }
                if (name.includes('ШТОРКА полупрозрачная СОТА'.toLowerCase()) && ind3.toLowerCase().includes('СОТА полупрозрачная'.toLowerCase())) {
                    if ( name.includes(' сота') && name.includes(ind4.toLowerCase()) ){
                        kolvo = ((w / 1000) * h / 7.7 * 10  / 1000 ).toFixed(3);
                    }
                }

                if (ind3.toLowerCase().includes('однослойн'.toLowerCase())) {
                    if ( name.includes('однослойн') && !name.includes('ПЛИССИРОВАННАЯ'.toLowerCase()) && name.includes(ind4.toLowerCase())){
                        kolvo = ((w / 1000) * h / 7.7 * 10  / 1000 ).toFixed(3);
                    }

                }

                if ( name.includes('darkout') &&  ind3.toLowerCase().includes('Dark out'.toLowerCase())) {
                    if ( name.includes(ind4.toLowerCase())){
                        kolvo = ((w / 1000) * h / 7.7 * 10  / 1000 ).toFixed(3);
                    }

                }

            }

            //     'Полупрозрачная' : 'Полупрозрачная',
            //    'Dark out' : 'Dark out  90% затемнения',
            //    'СОТЫ (BLACKOUT)' : 'СОТЫ black out КЛАССИК',
            //    'СОТА полупрозрачная' : 'СОТЫ black out ПРЕМИУМ',
            //    'BLACKOUT однослойный' : 'BLACKOUT однослойный',

            if (APP_TYPE === 'moskitoscompany'){

                if (name.includes('ШТОРКА ПРЕМИУМ СОТА'.toLowerCase()) && ind3.toLowerCase().includes('СОТЫ ПРЕМИУМ'.toLowerCase()) ) {
                    if (name.includes(ind4.toLowerCase()) ){
                        kolvo = ((w / 1000) * h / 7.7 * 10  / 1000 ).toFixed(3);
                    }
                }

                if (name.includes('ШТОРКА КЛАССИК СОТА'.toLowerCase()) && ind3.toLowerCase().includes('СОТЫ КЛАССИК'.toLowerCase())) {
                    if (name.includes(ind4.toLowerCase()) ){
                        kolvo = ((w / 1000) * h / 7.7 * 10  / 1000 ).toFixed(3);
                    }
                }

                if (name.includes('ПЛИССИРОВАННАЯ ШТОРКА ИЗ ПОЛИЭСТЕРА'.toLowerCase()) && ind3=='Полупрозрачная') {
                    if (name.includes('ПЛИССИРОВАННАЯ ШТОРКА ИЗ ПОЛИЭСТЕРА'.toLowerCase()) && name.includes(ind4.toLowerCase() + ' ') ){
                        kolvo = ((w - 2) * h / 2.2 * 0.028  / 10000 ).toFixed(3);
                    }
                }

                if (ind3.toLowerCase().includes('однослойн'.toLowerCase())) {
                    if ( name.includes('однослойн') && !name.includes('ПЛИССИРОВАННАЯ'.toLowerCase()) && name.includes(ind4.toLowerCase())){
                        kolvo = ((w / 1000) * h / 7.7 * 10  / 1000 ).toFixed(3);
                    }

                }

                if ( name.includes('darkout') &&  ind3.toLowerCase().includes('Dark out'.toLowerCase())) {
                    if ( name.includes(ind4.toLowerCase())){
                        kolvo = ((w / 1000) * h / 7.7 * 10  / 1000 ).toFixed(3);
                    }

                }

            }

            if (name.includes('нить') && name.includes(ind6.toLowerCase())) {
                kolvo = ((w * 4 + h * 2 + 300) * 2 / 1000).toFixed(3);
            }
            if (name.includes('вставка')) {
                kolvo = ((w - 4) * 2/ 1000).toFixed(3);
            }

            if (name.includes('комплектующие') && name.includes(ind5.toLowerCase())) {
                kolvo = (1).toFixed(3);
            }

            if (name.includes('заклепки')) {
                kolvo = (8).toFixed(3);
            }

            if (name.includes(ind7.toLowerCase())) {
                kolvo = 1;
            }

            if (name.includes('работа')) {
                kolvo = 1;
            }

            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }

          /*  if (name.includes('монтаж')) {
                montage_item = item;
            }*/
        });

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);


        /*let mprice = Math.round((result.price.rozn / quantity) / 100 * montage_item.procentSpisania / 100) * 100;
        montage_price = +(montage_item.opt_price > mprice ? montage_item.opt_price * quantity : mprice * quantity).toFixed(2);
        dispatch('mounting', {item: montage_item, price: montage_price});*/


        dispatch('item', result);
    }, 250);

    change();
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <!--<pre>{JSON.stringify(data, null, 4)}</pre>-->
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row d-flex">
            <div class="col-12 col-sm-6">
                <div class="row">
                    <span class="badge-danger text-white small rounded-2 text-center text-uppercase"> { ($width > (options.recomend && options.recomend.width ? options.recomend.width : 6000) || $height > (options.recomend && options.recomend.height ? options.recomend.height : 6000)) ? 'Изделие с данным размером не подлежит гарантии' : '' }</span>
                </div>
                <div class="row">

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">

                                <label class="form-label">200 ≥ Шир., мм ≥ { options.recomend && options.recomend.width ? options.recomend.width : 6000 }</label>
                                <input type="number"
                                       class="form-control text-center { $width > (options.recomend && options.recomend.width ? options.recomend.width : 6000) ? 'text-danger' : '' }"
                                       step="10"
                                       min="200"
                                       max="{ options.max && options.max.width ? options.max.width : 6000 }"
                                       bind:value={$width} use:validate_int={$width}>
                            </div>
                        </div>
                    </div>

                    <div class="col-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">200 ≥ Выс., мм ≥ { options.recomend && options.recomend.height ? options.recomend.height : 3000 }</label>
                                <input type="number"
                                       class="form-control text-center { $height > (options.recomend && options.recomend.height ? options.recomend.height : 3000) ? 'text-danger' : '' }"
                                       step="10"
                                       min="200"
                                       max="{ options.max && options.max.height ? options.max.height : 3000 }"
                                       bind:value={$height} use:validate_int={$height}>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Цвет профиля</label>
                                <select class="form-control form-select" bind:value={ind2} >
                                    {#each Object.entries(color) as [value]}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                 </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Вид шторы</label>
                                <select class="form-control form-select"
                                        bind:value={ind3}
                                        on:change={() => ind4 = (ind3 === 'Dark out' ? shtoryBlackoutcolor: ind3 === 'Полупрозрачная' ? shtoryPoluprozcolor: ind3 === 'Не прозрачная (BLACKOUT)' ? shtoryBlackoutcolor: (ind3 === 'СОТА полупрозрачная' || ind3 === 'СОТЫ КЛАССИК') ? shtorySotaPoluprozcolor:ind3 === 'BLACKOUT однослойный' ? shtoryBlackoutodnosloy:shtorySotacolor)[0]}>
                                    {#each Object.entries(shtorytypes) as [value, name]}
                                        <option value="{value}">{name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Цвет шторы</label>
                                <select class="form-control form-select" bind:value={ind4}>
                                    {#each (ind3 === 'Dark out' ? shtoryBlackoutcolor: ind3 === 'Полупрозрачная' ? shtoryPoluprozcolor: ind3 === 'Не прозрачная (BLACKOUT)' ? shtoryBlackoutcolor:(ind3 === 'СОТА полупрозрачная' || ind3 === 'СОТЫ КЛАССИК') ? shtorySotaPoluprozcolor:ind3 === 'BLACKOUT однослойный' ? shtoryBlackoutodnosloy:shtorySotacolor) as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Цвет комплектующих</label>
                                <select class="form-control form-select" bind:value={ind5}>
                                    {#each komplektcolor as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Цвет нити</label>
                                <select class="form-control form-select" bind:value={ind6}>
                                    {#each nitcolor as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Упаковка</label>
                                <select class="form-control form-select" bind:value={ind7}>
                                    {#each upakovka as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="col-12 col-sm-6 text-center d-flex order-last  order-sm-first justify-content-around">
                <img style="max-height: 300px" class="img-fluid p-3" src="/img/plisse/PlisseShtory.jpeg"/>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1" bind:value={$count} use:validate_int={count}>
                    </div>
                </div>
            </div>
            <RalColor color={ind2} bind:comment={$comment}/>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}


